module.exports = __webpack_public_path__ + "img/7.0cf3c067.png";